<template>
  <div class="modal-backdrop">
    <!-- <div class="modal-backdrop" @click.self="$emit('close')"> -->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Modal'
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

p {
  white-space: initial;
}

.ly_pop_head {
  color: #125c83;
  font-size: 16px;
  font-weight: 500;
  line-height: 64px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.card {
  background-color: #f0f5fa;
  padding: 20px;
  border-radius: $border-radius;
  box-shadow: $box-shadow-card;
  border: 2px solid #fff;
  max-width: 700px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.modal-header,
.modal-footer {
  display: flex;
}

.modal-header {
  padding: 0px 0px;
  margin-top: 30px;
  justify-content: space-between;
  font-size: 1.8rem;
  font-weight: bold;
  display: block;
  text-align: center;
}

.modal-footer {
  justify-content: flex-end;
  padding: 8px 0px 0px;
}

.modal-body {
  position: relative;
  padding: 20px 0px;
}

.ly_pop_msg {
  margin-top: 40px;
}

@media (max-width: 800px) {
  .ly_pop_msg {
    width: 95vw;
  }
}
</style>
